import { Err, Ok } from '@sniptt/monads';
import { makeSwapErrorRight } from '../../../utils';
import { relayTokenToAssetId } from './relayTokenToAssetId';
export const relayTokenToAsset = (relayToken, assets) => {
    const assetId = relayTokenToAssetId(relayToken);
    const maybeAsset = assets[assetId];
    if (maybeAsset)
        return Ok(maybeAsset);
    return Err(makeSwapErrorRight({
        message: 'Unknown relay token',
    }));
};
